module.exports = __webpack_public_path__ + "img/foto_blur_planten_h400.e9ca7412.jpg";